export const isDebug = false

export const isUseFirebaseEmulators = false

const firebaseEmulatorConfigHost = 'localhost'

const firebaseEmulatorConfigPorts = {
  auth: 9099,
  firestore: 8080,
  functions: 5001,
}

export const firebaseEmulatorConfig = {
  host: firebaseEmulatorConfigHost,
  ports: firebaseEmulatorConfigPorts,
  uris: {
    auth: `http://${firebaseEmulatorConfigHost}:${firebaseEmulatorConfigPorts.auth}`,
  },
}
export const staffersCoreApi = ''

export const isUseRegionsConst = true

// TODO
export const sharedConfigRegions = [
  {
    coordinates: { latitude: 59.9138688, longitude: 10.752245399999993 },
    enabled: true,
    size: 200,
    cityName: 'Oslo',
    id: 'KUNJNidCQxrXoZAO2NFe',
    countryName: 'Norway',
    isTestingEnabled: false,
    updatedAt: { seconds: 1734615912, nanoseconds: 532000000 },
  },
  {
    cityName: 'Tromsø',
    size: 50,
    isTestingEnabled: true,
    coordinates: { latitude: 69.6497717, longitude: 18.984122 },
    countryName: 'Norway',
    id: 'LU3IRg1fCXNuqlQrt0uU',
    enabled: true,
    updatedAt: { seconds: 1734615912, nanoseconds: 546000000 },
  },
  {
    coordinates: { latitude: 58.9695534, longitude: 5.726219 },
    enabled: true,
    size: 80,
    cityName: 'Stavanger',
    id: 'PfJKiPNXJRxefGalqWaB',
    countryName: 'Norway',
    isTestingEnabled: false,
    updatedAt: { seconds: 1734615912, nanoseconds: 575000000 },
  },
  {
    size: 100,
    coordinates: { latitude: 59.33036209999999, longitude: 18.0586789 },
    countryName: 'Sweden',
    id: 'QdxdJtyAWRXMOJE45tcY',
    isTestingEnabled: false,
    enabled: true,
    cityName: 'Stockholm',
    updatedAt: { seconds: 1734615912, nanoseconds: 594000000 },
  },
  {
    coordinates: { latitude: 58.15991189999999, longitude: 8.0182064 },
    cityName: 'Kristiansand',
    size: 80,
    id: 'U9X0s243QRLMEnufUIlD',
    enabled: true,
    countryName: 'Norway',
    isTestingEnabled: false,
    updatedAt: { seconds: 1734615912, nanoseconds: 618000000 },
  },
  {
    coordinates: { latitude: 63.4305149, longitude: 10.39505280000003 },
    enabled: true,
    size: 100,
    cityName: 'Trondheim',
    id: 'WDa30AeGtKJLRSlXKiU5',
    countryName: 'Norway',
    isTestingEnabled: false,
    updatedAt: { seconds: 1734615912, nanoseconds: 633000000 },
  },
  {
    size: 80,
    coordinates: { latitude: 57.709123, longitude: 11.9729997 },
    id: 'f8F1JaE5HSaCDF5VETqu',
    countryName: 'Sweden',
    isTestingEnabled: false,
    enabled: true,
    cityName: 'Göteborg',
    updatedAt: { seconds: 1734615912, nanoseconds: 656000000 },
  },
  {
    coordinates: { latitude: 59.32932349999999, longitude: 18.0685808 },
    cityName: 'Stockholm',
    size: 200,
    countryName: 'Sweden',
    id: 'fofQXjC4d18BlwgRcSx0',
    enabled: true,
    isTestingEnabled: true,
    updatedAt: { seconds: 1734615912, nanoseconds: 680000000 },
  },
  {
    cityName: 'Tønsberg',
    size: 50,
    coordinates: { latitude: 59.26756990000001, longitude: 10.4075608 },
    id: 'hhhvKWmYCeZ81eP2JfsW',
    countryName: 'Norway',
    isTestingEnabled: true,
    enabled: true,
    updatedAt: { seconds: 1734615912, nanoseconds: 722000000 },
  },
  {
    coordinates: { latitude: 60.38883629999999, longitude: 5.329812599999999 },
    size: 80,
    cityName: 'Bergen',
    id: 'rpKJZhF2pN8mJi8mRq0X',
    enabled: true,
    countryName: 'Norway',
    isTestingEnabled: false,
    updatedAt: { seconds: 1734615912, nanoseconds: 748000000 },
  },
  {
    size: 80,
    cityName: 'Malmö',
    coordinates: { latitude: 55.604981, longitude: 13.003822 },
    countryName: 'Sweden',
    id: 'tnGGQIcs86n52bCemswU',
    enabled: true,
    isTestingEnabled: true,
    updatedAt: { seconds: 1734615912, nanoseconds: 764000000 },
  },
  {
    cityName: 'Gothenburg',
    size: 150,
    coordinates: { latitude: 57.70887, longitude: 11.97456 },
    countryName: 'Sweden',
    id: 'vBRMtxFi4lWZd0MnPmfu',
    enabled: true,
    isTestingEnabled: true,
    updatedAt: { seconds: 1734615912, nanoseconds: 791000000 },
  },
]

export const MIN_WAGES = {
  no: {
    minimumWage: 210,
    Barback: {
      defaultWage: 220,
      wage: 220,
    },
    Barista: {
      defaultWage: 220,
      wage: 220,
    },
    Bartender: {
      defaultWage: 240,
      wage: 240,
    },
    Cashier: {
      defaultWage: 210,
      wage: 210,
    },
    Chef: {
      defaultWage: 240,
      wage: 240,
    },
    Cleaner: {
      defaultWage: 225,
      wage: 225,
    },
    Cover: {
      defaultWage: 210,
      wage: 210,
    },
    Dishwasher: {
      defaultWage: 220,
      wage: 220,
    },
    'Event Crew': {
      defaultWage: 210,
      wage: 210,
    },
    'Event Bartender': {
      defaultWage: 220,
      wage: 220,
    },
    'Host/Hostess': {
      defaultWage: 220,
      wage: 220,
    },
    Housekeeper: {
      defaultWage: 225,
      wage: 225,
    },
    'Kitchen Assistant': {
      defaultWage: 220,
      wage: 220,
    },
    Pizzaiolo: {
      defaultWage: 240,
      wage: 240,
    },
    Runner: {
      defaultWage: 220,
      wage: 220,
    },
    Waiter: {
      defaultWage: 220,
      wage: 220,
    },
    Wardrobe: {
      defaultWage: 210,
      wage: 210,
    },
  },
}

export const integrationApiUrl = 'https://api.staffers.com'

export const CRIIPTO_CLIENT_ID = 'urn:com:staffers:identity:app'
export const CRIIPTO_OIDC_DISCOVERY_URL = 'https://identity.staffers.com/.well-known/openid-configuration'
export const CRIIPTO_OIDC_REDIRECT_URL = 'https://europe-west1-staffers-production.cloudfunctions.net/bankid'
